import { mediaItems, rankingItems, featureItems, updateItems } from '@/mocks/homeData';

/* ===== Section: Media ===== */
export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          精彩视频
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer transition-all duration-200 hover:-translate-y-0.5">
              <div className="relative aspect-video w-full overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-foreground-950/20 flex items-center justify-center">
                  <span className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-2xl ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 text-xs bg-foreground-950/70 text-background-50 rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base text-foreground-800 mb-1 line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                  {item.summary}
                </p>
                <span className="text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>{item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== Section: Ranking ===== */
export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          吃瓜热搜榜
        </h2>
        <div className="bg-background-50 rounded-lg overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={idx}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className={`flex items-center gap-4 px-5 py-4 transition-colors duration-200 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-100`}
            >
              <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 truncate">
                  {item.title}
                  {item.tag && (
                    <span className={`ml-2 px-1.5 py-0.5 text-xs rounded whitespace-nowrap ${
                      item.tag === '爆' ? 'bg-primary-500 text-background-50' :
                      item.tag === '热' ? 'bg-accent-500 text-background-50' :
                      'bg-secondary-200 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</span>
                {item.trend === 'up' && <i className="ri-arrow-up-line text-primary-500 text-sm"></i>}
                {item.trend === 'new' && <i className="ri-add-line text-accent-500 text-sm"></i>}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== Section: Features ===== */
export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          特色优势
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featureItems.map((item, idx) => (
            <div key={idx} className="text-center p-6">
              <span className={`w-14 h-14 mx-auto rounded-2xl flex items-center justify-center mb-4 ${
                idx === 0 ? 'bg-primary-100' :
                idx === 1 ? 'bg-accent-100' :
                idx === 2 ? 'bg-secondary-100' :
                'bg-background-200'
              }`}>
                <i className={`${item.icon} text-xl ${
                  idx === 0 ? 'text-primary-500' :
                  idx === 1 ? 'text-accent-600' :
                  idx === 2 ? 'text-secondary-500' :
                  'text-foreground-600'
                }`}></i>
              </span>
              <h3 className="text-base md:text-lg text-foreground-800 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ===== Section: Updates ===== */
export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          最新动态
        </h2>
        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-4 top-0 bottom-0 w-px bg-background-300"></div>
          {updateItems.map((item, idx) => (
            <div key={idx} className="relative mb-6 last:mb-0">
              <span className={`absolute -left-[21px] md:-left-[23px] top-1 w-3 h-3 rounded-full border-2 ${
                item.tag === '最新' || item.tag === '热门'
                  ? 'bg-primary-500 border-primary-300'
                  : 'bg-background-300 border-background-200'
              }`}></span>
              <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-4">
                <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{item.date}</span>
                <p className="text-sm text-foreground-700">
                  {item.title}
                  {item.tag && (
                    <span className={`ml-2 px-1.5 py-0.5 text-xs rounded whitespace-nowrap ${
                      item.tag === '最新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '热门' ? 'bg-accent-100 text-accent-800' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}